import logEventConversionUtil from 'modules/conversion/utils/log-event'
import { CONVERSION_EVENT } from 'modules/conversion/constants'
import getPathnameLocationUtil from 'utils/location/get-pathname'
import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'
import stringifyQueryObjectUtil from 'utils/object/stringify-query'
import { omit } from 'lodash'
import getPathWithoutQueryStringUtil from 'utils/string/get-path-without-query'
import logUtil from 'utils/log'

/**
 * @param props
 * @param {ProductVariantCollection} props.productVariant
 * @param props.price
 * @param {ProductFrontend} props.product
 * @param props.discountPrice
 */
export default function logAddToCartConversionEventUtil (props) {
  const {
    productVariant,
    price,
    product,
    discountPrice
  } = props
  logUtil('logAddToCartConversionEventUtil').debug('props=', props)

  const pathname = getPathnameLocationUtil()
  const queryParams = getQueryParamsFromStringObjectUtil()
  const queryString = stringifyQueryObjectUtil(
    omit(queryParams, [
      'variant_id',
      'product_id'
    ])
  )

  const list = `${getPathWithoutQueryStringUtil(pathname)}${queryString ? `?${queryString}` : ''}`

  const properties = {
    ecommerce: {
      currencyCode: 'USD',
      add: {
        actionField: {
          // this should be the collection page URL that user clicked product from
          list
        },
        products: [
          {
            name: product?.title,
            id: productVariant?.sku,
            product_id: productVariant?.product_id,
            variant_id: productVariant?.variant_id,
            image: productVariant?.image_url,
            price: discountPrice || price,
            compare_at_price: price,
            brand: product?.vendor || '',
            variant: productVariant?.variant_name,
            category: product?.product_type || '',
            // this should be the collection page URL that user clicked product from
            list
          }
        ]
      }
    }
  }

  logUtil('logAddToCartConversionEventUtil').debug('properties=', properties)
  logEventConversionUtil(CONVERSION_EVENT.ADD_TO_CART, properties)
}
